import React from 'react';

/**
 * @typedef {{
 *  element: HTMLElement | string,
 * }} UseElementHeightProps
 */

/**
 * @param {UseElementHeightProps} props
 * @returns {number}
 */
const useElementHeight = (element) => {
  const [height, setHeight] = React.useState(0);

  React.useLayoutEffect(() => {
    const htmlElement = typeof element === 'string' ? document.querySelector(element) : element;
    if (htmlElement) {
      const observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          setHeight(entry.contentRect.height);
        });
      });

      observer.observe(htmlElement);
      setHeight(htmlElement.offsetHeight);
      return () => observer.disconnect();
    }

    return undefined;
  }, [element]);

  return height;
};

export default useElementHeight;
